module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_Vitra02.0108.png.2667271d.jpg";